export const MAX_MINOR_AMOUNT = 2_147_483_647;

export function parseMajorAmount(value: string, maximum = MAX_MINOR_AMOUNT): number {
  const input = value.trim();
  if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{0,2})?$/.test(input)) throw new Error('Enter a non-negative amount with at most two decimal places; use valid thousands grouping.');
  const [whole, fraction = ''] = input.replaceAll(',', '').split('.');
  let amount = 0;
  for (const digit of `${whole}${fraction.padEnd(2, '0')}`) {
    amount = amount * 10 + Number(digit);
    if (!Number.isSafeInteger(amount) || amount > maximum) throw new Error('Amount exceeds the supported limit.');
  }
  return amount;
}

export function formatMinorAmount(amount: number, grouping = false): string {
  if (!Number.isSafeInteger(amount)) throw new Error('Invalid stored monetary amount.');
  const absolute = Math.abs(amount);
  let whole = String(Math.floor(absolute / 100));
  if (grouping) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${amount < 0 ? '-' : ''}${whole}.${String(absolute % 100).padStart(2, '0')}`;
}

export function normalizedMajorAmount(value: string, maximum = MAX_MINOR_AMOUNT): string {
  return formatMinorAmount(parseMajorAmount(value, maximum));
}

export function checkedMinorTotal(values: number[], maximum = MAX_MINOR_AMOUNT): number {
  let total = 0;
  for (const amount of values) {
    if (!Number.isSafeInteger(amount) || amount < 0 || total > maximum - amount) throw new Error('Invoice total exceeds the supported limit.');
    total += amount;
  }
  return total;
}
